import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, delayWhen } from 'rxjs/operators';
import { AlertService, IAlert } from '@app/core/services/alert.service';
import { Animations } from '@app/shared/animations/animations';
import { interval } from 'rxjs';
import { version, versionDate } from '@package';
import { EsriAuthService } from '@app/core/services/esri-auth.service';
import { environment } from '@env/environment';
import { ApiService } from '@app/core/services/api.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  animations: [Animations.fadeInOut]
})
export class NavbarComponent implements OnInit {
  @Input() dropdownOpen = false;
  @Input() loading = true;
  public loggedOut = false;
  public accountType: string;
  public alert: IAlert;
  public version = version;
  public versionDate = versionDate;
  public username: string;
  public helpUrl = environment.help;
  public faqUrl = environment.faq;

  constructor(private api: ApiService, private router: Router, private alertService: AlertService, private authService: EsriAuthService) { }

  ngOnInit() {
    this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.username = sessionStorage.getItem('UserName');
        this.accountType = sessionStorage.getItem('accountType');
        const token = sessionStorage.getItem('PortalToken');
        token ? this.loggedOut = false : this.loggedOut = true;
      });

    this.alertService.alert$.pipe(
      delayWhen((alert: IAlert) => this.alert ? interval(alert.duration - 500) : interval(0))
    ).subscribe(alert => {
      this.alert = alert;
      setTimeout(() => this.alert = null, alert.duration);
    });
  }

  public logout(): void {
    this.authService.signOut();
    window.sessionStorage.removeItem('accountType');
    this.loggedOut = true;
  }

  public async getTables() {
    const tables = await this.api.getTables().toPromise();
  }

}
